import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';
import { RpcRequestParams } from '../types/Rpc';

export interface MoneyTransferProps {
  balanceId: string | number;
  balanceTo: string | number;
  amount: number;
  currency: string;
}

const getBalanceManageList = (params: RpcRequestParams): Promise<any> => {
  const { sort, filter = {}, pagination} = params;
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.BalanceManage_List,
          payload: { ...filter, orderBy: sort, pagination },
        },
      ],
      isCancelable: true,
    })
    .then((data: any) => ({
      items: data.rows,
      totalRows: Infinity,
    }));
};


const createMoneyTransfer = (params: MoneyTransferProps): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.BalanceManage_MoneyTransfer,
          payload: params,
        },
      ],
      isCancelable: true,
    });
};

export {
  getBalanceManageList,
  createMoneyTransfer
};
